module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dde8aa58f32f9d0e50af951995bdca7f.png";